<template>
  <div class="suggestion-container">
    <b-form-input
      :value="value"
      @input="updateValue"
      @focus="showSuggestions = true"
      @blur="handleBlur"
      placeholder="Nhập lý do"
    />

    <b-list-group v-show="showSuggestions && filteredItems.length > 0" class="suggestion-list">
      <b-list-group-item
        v-for="(item, index) in filteredItems"
        :key="index"
        @mousedown.prevent="selectItem(item)"
        class="suggestion-item"
        href="#"
        action
      >
        {{ item }}
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
  export default {
    name: 'SuggestionInput',
    props: {
      value: {
        type: String,
        default: '',
      },
      items: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        showSuggestions: false,
      }
    },
    computed: {
      filteredItems() {
        if (!this.value) {
          return this.items
        }
        const searchLower = this.value.toLowerCase()
        return this.items.filter(item => item.toLowerCase().indexOf(searchLower) >= 0)
      },
    },
    methods: {
      updateValue(value) {
        this.showSuggestions = true
        this.$emit('input', value)
      },
      selectItem(item) {
        this.$emit('input', item)
        this.$emit('item-selected', item)
        this.showSuggestions = false
      },
      handleBlur() {
        setTimeout(() => {
          this.showSuggestions = false
        }, 200)
      },
    },
  }
</script>

<style scoped>
  .suggestion-container {
    position: relative;
    width: 100%;
    max-width: 300px;
  }

  .suggestion-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    margin-top: -1px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .suggestion-item {
    cursor: pointer;
  }
</style>
